import type { TaskListItem } from './jobTask';

export type LooseTaskListItem = Omit<TaskListItem, 'ext'> & {
    ext?: TaskListItem['ext'] | string | null;
};

const isRecord = (value: unknown): value is Record<string, unknown> => {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};

/** 任务接口和通知可能返回 JSON 字符串 ext，入库前统一成对象。 */
export const normalizeTaskListItem = (item: LooseTaskListItem): TaskListItem => {
    if (isRecord(item.ext)) return item as TaskListItem;

    if (typeof item.ext === 'string') {
        try {
            const ext = JSON.parse(item.ext) as unknown;
            return { ...item, ext: isRecord(ext) ? ext : {} } as TaskListItem;
        } catch {
            // 历史任务可能存在非法 ext；任务仍展示，仅隐藏统计和下载入口。
        }
    }

    return { ...item, ext: {} as TaskListItem['ext'] };
};
